import React from 'react'
import { useTranslation } from 'react-i18next'
import { ControlledSelectField } from 'components/Shared/ControlledSelectField'
import { CURRENCY_CODES } from 'constants/currencies'

export function CurrencySelectField ({ fieldName, label, ...rest }) {
  const { t } = useTranslation()

  return (
    <ControlledSelectField
      options={CURRENCY_CODES}
      getOptionLabel={item => item}
      getOptionValue={item => item}
      label={t(label)}
      fieldName={fieldName}
      disableClear
      {...rest}
    />
  )
}